import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DateTime } from 'luxon';
import { CoachingSessionTypeDTO } from 'src/app/private/shared/dtos/coaching-session.dto';
import { CompetencyDTO } from 'src/app/private/shared/dtos/competencies.dto';
import { UserLiteDTO } from '../state/user/user.dto';
import { dateTimeFromNgbDate } from '../utilities/date-helpers';
import { CoachlogSearchPayloadItemsDTO } from './coachlog-search-payload.dto';
import { DistrictSimpleDto } from './district.dto';
import { SchoolDTO } from './school.dto';

export interface CoachingSessionFilterDTO {
  coacheeList: UserLiteDTO[] | null;
  coachList: UserLiteDTO[] | null;
  district: DistrictSimpleDto | null;
  schoolList: SchoolDTO[] | null;
  competencyList: CompetencyDTO[] | null;
  logType: CoachingSessionTypeDTO | null;
  fromDate: NgbDate;
  toDate: NgbDate;
  page?: number;
}

export const setDefaultCoachingSessionFilterDateRange = (): {
  toDate: NgbDate;
  fromDate: NgbDate;
} => {
  const currentDate = DateTime.now().set({ hour: 23, minute: 59, second: 59 });
  const toDate = currentDate.plus({ days: 7 });
  const fromDate = currentDate.minus({ days: 180 });
  return {
    toDate: new NgbDate(toDate.year, toDate.month, toDate.day),
    fromDate: new NgbDate(fromDate.year, fromDate.month, fromDate.day),
  };
};

export const emptyCoachingSessionFilters = (): CoachingSessionFilterDTO => {
  const date = setDefaultCoachingSessionFilterDateRange();
  return {
    coacheeList: null,
    coachList: null,
    district: null,
    schoolList: null,
    competencyList: null,
    logType: null,
    fromDate: date.fromDate,
    toDate: date.toDate,
    page: 1,
  };
};

export const coachingSessionFilterDTOToCoachlogSearchPayloadItemsDTO = (
  filters: CoachingSessionFilterDTO
): CoachlogSearchPayloadItemsDTO => ({
  keywords: '',
  coach_items: filters.coachList ?? [],
  school_items: filters.schoolList ?? [],
  competency_items: filters.competencyList ?? [],
  district_item: filters.district ?? undefined,
  logtype_item: filters.logType ?? undefined,
  from_date: dateTimeFromNgbDate(filters.fromDate).toSeconds(),
  to_date: dateTimeFromNgbDate(filters.toDate)
    .set({ hour: 23, minute: 59, second: 59 })
    .toSeconds(),
  coachee_items: filters.coacheeList ?? [],
  per_page: 50,
  sort_order: 'desc',
  own_only: 0,
  page: filters.page ?? 1,
});
